import { IconButton, Tooltip } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import loading3 from '../../assets/images/loading3.gif';
import { htmlToText } from '../../../utilities/formUtils';
import { Filters, VdsTableProps } from './VdsTable';
import { columnTypeGuard } from './VdsTableHeader';

/** Traduzioni di default per le sezioni della tabella */
const tsl = {
    noData: 'No data'
}

const ContainerWithTooltip = React.forwardRef(function ContainerWithTooltip({ children, ...props }: any, ref: any) {
    return <div {...props} ref={ref}>{children}</div>
});

type ConditionalVdsTableBodyProps<R> = {
    loader?: boolean;
    totalCount: number;
    pageSize: number;
    columns: VdsTableProps<R>['columns'];
    options: VdsTableProps<R>['options'];
    events: VdsTableProps<R>['events'];
    data: R[];
    filters: Filters;
}

export const ConditionalVdsTableBody: <R>(props: ConditionalVdsTableBodyProps<R>) => React.ReactElement = (props) => {

    return (
        <TableBody>
            {props.loader && (
                <TableRow>
                    <TableCell colSpan={props.columns.length} sx={{ textAlign: 'center' }}>
                        <div
                            style={{
                                height: '28px',
                                backgroundPosition: 'center',
                                backgroundImage: `url(${loading3})`,
                                backgroundRepeat: 'no-repeat',
                                opacity: 0.5,
                            }}
                        >
                        </div>
                    </TableCell>
                </TableRow>
            )}
            {!props.loader && !props.totalCount && (
                <TableRow>
                    <TableCell colSpan={props.columns.length} sx={{ textAlign: 'center', height: 28 }}>
                        <div>
                            {props.options?.localize?.noData || tsl.noData}
                        </div>
                    </TableCell>
                </TableRow>
            )}
            {!props.loader && props.totalCount > 0 && props.data.map((row, ri) => {
                return (
                    <TableRow
                        key={`body-row-${ri}`}
                        sx={(props.options?.selectedRow && props.options?.selectedRow(row)) ? {
                            ...(props.options?.rowStyle && props.options?.rowStyle(row)),
                            'td:first-of-type': {
                                borderLeft: '3px solid #0090D1',
                                borderTop: '1px solid #0090D1',
                                borderBottom: '1px solid #0090D1'
                            },
                            'td': {
                                borderTop: '1px solid #0090D1',
                                borderBottom: '1px solid #0090D1',
                            },
                            'td:last-child': {
                                borderTop: '1px solid #0090D1',
                                borderBottom: '1px solid #0090D1',
                                borderRight: '1px solid #0090D1',
                            }
                        } : {
                            ...(props.options?.rowStyle && props.options?.rowStyle(row)),
                        }}
                        hover
                    >
                        {props.columns.map((column, i) => {

                            if (columnTypeGuard(column)) {

                                return (
                                    <TableCell
                                        key={`row-${ri}-cell-${i}`}
                                        onClick={() => {
                                            if (!column.ignoreClick) {
                                                if (props?.options?.disableRow) {
                                                    const disabled = props.options.disableRow(row);
                                                    if (!disabled) {
                                                        props?.events?.onRowClick && props.events.onRowClick(row, props.filters);
                                                    }
                                                } else {
                                                    props?.events?.onRowClick && props.events.onRowClick(row, props.filters);
                                                }
                                            }
                                        }}
                                        style={{
                                            cursor: (!(column.ignoreClick || (props?.options?.disableRow && props?.options?.disableRow(row))) && props.events?.onRowClick) ? 'pointer' : 'text',
                                            wordBreak: 'break-word',
                                            whiteSpace: 'break-spaces',
                                            ...column.style
                                        }}
                                    >
                                        {column?.tooltip ? (
                                            <Tooltip title={(column?.tooltip as any)(row) || ''} placement="bottom" arrow>
                                                <span>
                                                    <ContainerWithTooltip>
                                                        {htmlToText(column.render(row, props.filters) as string)}
                                                    </ContainerWithTooltip>
                                                </span>
                                            </Tooltip>
                                        ) : htmlToText(column.render(row, props.filters) as string)}
                                    </TableCell>
                                )
                            } else {

                                if (column.hidden) {

                                    return (
                                        <TableCell
                                            key={`row-${ri}-cell-${i}`}
                                            style={{
                                                wordBreak: 'break-word',
                                                ...column.style
                                            }}
                                        >
                                            {!column.hidden(row) && (
                                                <Tooltip title={'' + column.tooltip || ''}>
                                                    <span>
                                                        <IconButton onClick={() => column.onClick(row, props.filters)} size="small" disabled={column.disabled && column.disabled(row)}>
                                                            {(typeof column.icon === 'function' ? column.icon(row, props.filters) : column.icon) as any}
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                    );
                                }

                                return (
                                    <TableCell
                                        key={`row-${ri}-cell-${i}`}
                                        style={{
                                            wordBreak: 'break-word',
                                            ...column.style
                                        }}
                                    >
                                        <Tooltip title={'' + column.tooltip || ''}>
                                            <span>
                                                <IconButton onClick={() => column.onClick(row, props.filters)} size="small" disabled={column.disabled && column.disabled(row)}>
                                                    {(typeof column.icon === 'function' ? column.icon(row, props.filters) : column.icon) as any}
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </TableCell>
                                );
                            }
                        })}
                    </TableRow>
                );
            })}
        </TableBody>
    );
}